"use strict";

exports.__esModule = true;
exports.default = raf;
function raf(callback) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(callback);
  }

  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;

  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
}


//////////////////
// WEBPACK FOOTER
// ./~/google-map-react/lib/utils/raf.js
// module id = 1157
// module chunks = 2